import { usePlayerStore } from "../state/playerStore";

export function LoadingScreen({ message }: { message?: string }) {
  const notice = usePlayerStore((s) => s.notice);
  return (
    <div className="fill center status">
      <div className="brand">GoCityScreens player</div>
      <div className="status-text">{notice ?? message ?? "Starting…"}</div>
    </div>
  );
}

export function ErrorScreen() {
  const error = usePlayerStore((s) => s.error);
  return (
    <div className="fill center status">
      <div className="brand">GoCityScreens player</div>
      <div className="status-text error">Could not start</div>
      <div className="status-detail">{error}</div>
      <div className="status-detail">Reload the player to try again.</div>
    </div>
  );
}

/** A recovery the device is waiting on, shown over playback without stopping it. */
export function NoticeOverlay() {
  const notice = usePlayerStore((s) => s.notice);
  if (!notice) return null;
  return (
    <div className="notice-overlay">{notice}</div>
  );
}
